<template>
  <div class="text-area">
    <label v-if="topLeftLabel" class="top-left-label">{{ topLeftLabel }}</label>
    <textarea class="input"
           v-on:input="onInput($event.target.value)"
           v-bind:value="value"
           :rows="rows"
           :autofocus="autofocus"
           :pattern="inputPattern"
           :placeholder="placeholder"
           :class="{empty: emptyValue, error}"
           :maxlength="maxLength" />
    <label class="top-right-label">{{ labelText }}</label>
  </div>
</template>

<script>

import _ from 'lodash';

export default {
  name: 'TextArea',
  props: {
    labelText: {
      type: String,
      default: '',
    },
    topLeftLabel: {
      type: String,
      default: '',
    },
    rows: {
      type: Number,
      default: 4,
    },
    value: {
      type: String,
      required: true,
    },
    onInput: {
      type: Function,
      required: true,
    },
    maxLength: {
      type: Number,
      default: 5000,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    inputPattern: {
      type: String,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  computed: {
    emptyValue() {
      return _.isEmpty(this.value);
    },
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/riseup-colors';

//Remove arraows from input type number

/* Chrome, Safari, Edge, Opera */
textarea::-webkit-outer-spin-button,
textarea::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
textarea[type=number] {
  -moz-appearance: textfield;
}

.text-area {
  position: relative;
  margin-bottom: 20px;
  width: 100%;
  height: 100%;

  .top-left-label {
    position: absolute;
    top: -12px;
    margin: 0;
    width: 100%;
    text-align: left;
    font-size: 11px;
    color: $riseup_gray_2;
    right: 0;
  }

  > .input {
    font-family: SimplerPro;
    width: 100%;
    height: 100%;
    font-size: 16px;
    line-height: 20px;
    border: 1px solid $riseup_gray_2;
    border-radius: 3px;
    color: $riseup_black;
    padding: 16px 20px;
    resize: none;

    &:focus {
      outline: none;
      border: 1px solid $riseup_blue;
    }

    &::placeholder {
      color: $riseup_gray_0;
    }

    &:not(.empty):not(:focus) ~ .top-right-label,
    &:focus ~ .top-right-label {
      position: absolute;
      top: -13px;
      font-size: 12px;
      color: $riseup_blue;
      transition: 300ms ease all;
      right: 0;
    }

    &:not(.empty):not(:focus) {
      border: 1px solid $riseup_blue;
    }

    &:not(.empty).error {
      border: 1px solid $riseup_danger_red;
    }

    &:not(.empty).error ~ .top-right-label {
      color: $riseup_danger_red;
    }

    &.empty:not(:focus) ~ .top-right-label {
      position: absolute;
      right: 10px;
      top: 6px;
      color: $riseup_gray_2;
      font-size: 20px;
      pointer-events: none;
      transition: 300ms ease all;
      line-height: 30px;
    }
  }
}

</style>
